import { useCallback, useEffect, useState } from 'react';

import { useAppContext } from '../../app/Context';
import { getCanFetchLocalData, getLocalData } from '../../db/local-storage';
import { getUserId } from '../../db/session';

const useMetadataFetcher = () => {
  const { isNewPresentation, presentationId, session } = useAppContext();

  const [isFetchingMetadata, setIsFetchingMetadata] = useState(true);

  const fetchMetadata = useCallback(
    async (presentationId: string) => {
      try {
        setIsFetchingMetadata(true);

        if (isNewPresentation == null || isNewPresentation) return;

        if (!session?.token) return;
        if (!session.userId) return;

        const localStorageUserId = getUserId();

        if (session.userId !== localStorageUserId) {
          await getLocalData({ presentationId });
          return;
        }

        const canFetchLocalData = getCanFetchLocalData();
        if (!canFetchLocalData) return;

        await getLocalData({ presentationId });
      } finally {
        setIsFetchingMetadata(false);
      }
    },
    [session?.userId, session?.token, isNewPresentation]
  );

  useEffect(() => {
    if (!presentationId) return;
    fetchMetadata(presentationId);
  }, [presentationId, fetchMetadata]);

  return { isFetchingMetadata };
};

export default useMetadataFetcher;
